import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export type TranslatedString = {
    key: string;
    params?: any;
};

export type TranslatableString = string | TranslatedString;


export function normalizeTranslatableString(translatableString: TranslatableString): TranslatedString {
    if (typeof translatableString === 'string') {
        return { key: translatableString };
    }
    return translatableString;
}

export function translateAll(translate: TranslateService, translated: TranslatedString[]): Observable<{ [key: string]: string }> {
    return forkJoin(translated.map((k) => {
        return translate.get(k.key, k.params);
    })).pipe(map(translations => {
        return translations.reduce((mapped, translation, index) => {
            mapped[translated[index].key] = translation;
            return mapped;
        }, { });
    }));
}
